import React, { useState, useEffect, useRef } from "react";
import "./HeaderSearch.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function HeaderSearch() {
  return (
    <div className='employee-header-search'>
      <i className='fa-solid fa-magnifying-glass'></i>
    </div>
  );
}

export default HeaderSearch;
